import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GrTypography } from "../inputs";
import styled from "@emotion/styled";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import classNames from "classnames";
import { useState } from "react";
import { GrMenu } from "./GrMenu";
import { GrIconButton } from "../buttons/GrIconButton";
import { GrIcon } from "../icons/GrIcon";
const StyledIconButton = styled(GrIconButton)(() => ({
    padding: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "16px",
    height: "16px",
}));
const StyledBreadcrumbs = styled(Breadcrumbs)(({ size }) => ({
    "& .MuiBreadcrumbs-separator": {
        position: "relative",
        top: "1px",
        margin: `0 ${size === "large" ? 4 : 2}px`,
    },
}));
export function GrBreadcrumbs({ size = "large", type, items, className }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const collapsedItems = type === "text-collapsed" ? items.slice(0, -2) : [];
    const remainingItems = type === "text-collapsed" ? items.slice(-2) : items;
    const isLast = (index) => index === remainingItems.length - 1;
    return (_jsxs(StyledBreadcrumbs, { className: classNames("GrBreadcrumbs", className), separator: _jsx(GrIcon, { type: "chevron-right", size: 12, color: "grey050" }), size: size, children: [type === "text-collapsed" && (_jsxs(_Fragment, { children: [_jsx(StyledIconButton, { isActive: !!anchorEl, iconType: "dot-horizontal", size: 12, onClick: e => {
                            setAnchorEl(e.currentTarget);
                        } }), _jsx(GrMenu, { anchorElement: anchorEl, onClose: () => setAnchorEl(null), size: "small", spacing: -1, items: collapsedItems.map(item => ({
                            type: "item",
                            text: item.label,
                            onClick: () => {
                                if (item.href) {
                                    window.location.href = item.href;
                                }
                            },
                        })), position: { vertical: "bottom", horizontal: "left" } })] })), remainingItems.map((item, index) => (_jsx(Link, { underline: item.href ? "hover" : "none", href: item.href, style: { cursor: item.href ? "cursor" : "default" }, children: _jsx(GrTypography, { type: size === "large"
                        ? isLast(index)
                            ? "Visual.EN.Subtitle04"
                            : "Visual.EN.Body04"
                        : isLast(index)
                            ? "Visual.EN.Caption01"
                            : "Visual.EN.Caption02", color: isLast(index) ? "grey080" : "grey070", children: item.label }) }, index)))] }));
}
//# sourceMappingURL=GrBreadCrumbs.js.map